import React from 'react';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import ApiService from '../../services/ApiService';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../redux/auth';

function PayPalButtonsWrapper({ amount, payment_type, chat_plan_id, clientId }) {
    const { userData } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const getUserDetails = async () => {
        var response = await new ApiService().POST("/user-info", { userid: userData.id });
        if (response.data && response.data.user_details && response.data.user_details.length > 0) {
            var resData = response.data.user_details[0];
            dispatch(authActions.UpdateUserData(resData));
        }
    };

    const initialOptions = {
        "client-id": clientId,
        currency: "USD",
        intent: "capture",
    };

    return (
        <PayPalScriptProvider options={initialOptions}>
            <div className="stripeCard-center">
                <div className="card pd-20" style={{ 
                    maxWidth: '450px', 
                    width: '100%',
                    margin: '0 auto', 
                    padding: '30px', 
                    borderRadius: '16px', 
                    background: '#1c1c24', 
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.35)', 
                    border: '1px solid #2d2d3a',
                    color: '#fff' 
                }}>
                    <h5 className="card-body-title text-center" style={{ marginBottom: '15px', color: '#fff', fontWeight: '600' }}>Recharge with PayPal</h5>
                    <div style={{ textAlign: 'center', marginBottom: '25px', fontSize: '20px', fontWeight: 'bold', color: '#ffd166' }}>
                        Amount: ${amount}
                    </div>
                    <PayPalButtons
                        style={{ layout: "vertical" }}
                    createOrder={async (data, actions) => {
                        try {
                            const response = await new ApiService().POST('/create-paypal-order', {
                                userid: userData.id,
                                amount: amount,
                                payFor: chat_plan_id ? 'chat_subscription' : 'wallet',
                                chat_plan_id: chat_plan_id ? chat_plan_id : "",
                                pay_platform: "web"
                            });
                            if (response.data.status === '1') {
                                return response.data.orderID;
                            } else {
                                toast.error(response.data.message || "Failed to create order");
                                throw new Error(response.data.message);
                            }
                        } catch (err) {
                            console.error(err);
                            toast.error("Error creating PayPal order");
                        }
                    }}
                    onApprove={async (data, actions) => {
                        try {
                            const payload = {
                                userId: userData.id,
                                orderID: data.orderID,
                                amount: amount,
                                payFor: chat_plan_id ? 'chat_subscription' : 'wallet',
                                chat_plan_id: chat_plan_id ? chat_plan_id : "",
                                pay_platform: "web"
                            };

                            const response = await new ApiService().POST('/capture-paypal-order', payload);
                            if (response.data.status === '1') {
                                toast.success("Payment successful!");
                                await getUserDetails();
                                navigate('/payment-status', { state: { status: 'succeeded' } });
                            } else {
                                toast.error(response.data.message || "Capture failed");
                                navigate('/payment-status', { state: { status: 'failed' } });
                            }
                        } catch (err) {
                            console.error(err);
                            toast.error("Error capturing PayPal payment");
                            navigate('/payment-status', { state: { status: 'failed' } });
                        }
                    }}
                    onError={(err) => {
                        console.error(err);
                        toast.error("PayPal checkout error");
                        navigate('/payment-status', { state: { status: 'failed' } });
                    }}
                />
            </div>
            </div>
        </PayPalScriptProvider>
    );
}

export default PayPalButtonsWrapper;
